import React, { useCallback, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import QuickSearch from '../Components/QuickSearch';
import {
    query,
    setSearchQuery,
    handleKeyDown,
    setState, show
} from '../Actions/QuickSearch.action';

const headerSearchIsOpenClass = 'search-is-open';

const QuickSearchContainer = ({ className, isMuurikka }) => {
    const dispatch = useDispatch();
    const {
        query: searchQuery,
        result,
        showResult,
        showFullForm,
        selectedItem,
        isLoading,
    } = useSelector(state => state.quickSearch);

    const lastClickedNode = useRef(null);
    const searchContainer = useRef(null);

    const toggle = useCallback(() => {
        dispatch(show(!showFullForm));
    }, [showFullForm])

    // Escape key handler
    const escapeHandler = (event) => {
        if (showFullForm && event.key === 'Escape') {
            toggle();
        }
    };

    // Document click handler
    const clickHandler = (event) => {
        lastClickedNode.current = event.target;
    };

    // On blur handler
    const onBlur = () => {
        if (!searchContainer.current || searchContainer.current.contains(lastClickedNode.current)) {
            return;
        }

        if (showFullForm) {
            toggle();

            const body = document.querySelector('body');
            if (body) {
                body.classList.remove('disable-scroll');
            }
        }
    };

    // Effect for event listeners
    useEffect(() => {
        document.addEventListener('keyup', escapeHandler);
        document.addEventListener('mousedown', clickHandler);

        return () => {
            document.removeEventListener('keyup', escapeHandler);
            document.removeEventListener('mousedown', clickHandler);
        };
    }, [showFullForm]);

    // ComponentDidUpdate equivalent
    useEffect(() => {
        if (selectedItem) {
            const selectedElement = document.querySelector('.quick-search-result__item--selected');
            if (selectedElement) {
                selectedElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
            }
        }

        const body = document.querySelector('body');
        if (body) {
            if (showFullForm) {
                body.classList.add('disable-scroll');
                isMuurikka ? muurikkaOpenActions() : haboOpenActions();
            } else {
                body.classList.remove('disable-scroll');
                isMuurikka ? muurikkaCloseActions() : haboCloseActions();
            }
        }
    }, [selectedItem, showFullForm]);

    // Debounced search logic
    const customDebounceTimeout = useRef(null);
    const onSearch = (text) => {
        dispatch(setSearchQuery(text));

        if (customDebounceTimeout.current) {
            clearTimeout(customDebounceTimeout.current);
        }

        customDebounceTimeout.current = setTimeout(() => {
            dispatch(query(text));
        }, 600);
    };

    const clearSearchQuery = () => {
        dispatch(setState({ showResult: false, query: '' }));
    };

    const haboOpenActions = () => {
        const header = document.querySelector('header.header');
        if (header) header.classList.add(headerSearchIsOpenClass);
    };

    const haboCloseActions = () => {
        const header = document.querySelector('header.header');
        if (header) header.classList.remove(headerSearchIsOpenClass);
    };

    const muurikkaOpenActions = () => {
        const header = document.querySelector('header.header');
        if (header) header.classList.add(headerSearchIsOpenClass);
    };

    const muurikkaCloseActions = () => {
        const header = document.querySelector('header.header');
        if (header) header.classList.remove(headerSearchIsOpenClass);
    };

    const onKeyDown = (event, opt) => {
        dispatch(handleKeyDown(event, opt));
    };

    const searchUrl = window.__litium.quickSearchUrl + (searchQuery.length > 0 ? `?q=${searchQuery}` : '');

    return (
        <div id="parent-container" ref={searchContainer} className={className || ''}>
            <QuickSearch
                lastClickedNodeRef={lastClickedNode}
                query={searchQuery}
                result={result}
                showResult={showResult}
                showFullForm={showFullForm}
                selectedItem={selectedItem}
                isLoading={isLoading}
                searchUrl={searchUrl}
                onSearch={onSearch}
                clearSearchQuery={clearSearchQuery}
                toggleShowFullForm={toggle}
                onKeyDown={onKeyDown}
                onBlur={onBlur}
            />
        </div>
    );
};

export default QuickSearchContainer;
